module.exports = __webpack_public_path__ + "static/media/c104_cd1.4ba3152c.jpeg";